import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ListItem, Button } from "@chakra-ui/react";

const MenuItem = ({ menuItem, isMobile = false, onItemClick }) => {
    const location = useLocation();
    
    // Add error handling for missing menuItem properties
    if (!menuItem || !menuItem.menuCode || !menuItem.displayname) {
        console.warn("Invalid menu item:", menuItem);
        return null;
    }
    
    const route = menuItem.route; // Use route directly from API
    const isActive = location.pathname === route;
    
    const handleClick = () => {
        if (onItemClick) {
            onItemClick();
        }
    };

    // Create SVG icon from savage property
    const renderSvgIcon = () => {
        if (menuItem.savage) {
            return (
                <span 
                    dangerouslySetInnerHTML={{ __html: menuItem.savage }}
                    style={{ 
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                />
            );
        }
        return null;
    };

    return (
        <ListItem m="0 0.3em" w={isMobile ? "100%" : "auto"}>
            <Link to={route} onClick={handleClick}>
                <Button
                    w={isMobile ? "100%" : "auto"}
                    leftIcon={renderSvgIcon()}
                    variant="noBorder-bgOpaque"
                    borderBottom={
                        isActive ? "1.7px solid white" : "none"
                    }
                >
                    {menuItem.displayname}
                </Button>
            </Link>
        </ListItem>
    );
};

export default MenuItem;